import React, { useEffect, useState } from "react"
import ClientReportCard from "../../components/ClientReportCard.molecule"
import Dropdown from "../../../../components/atoms/Dropdown.atom"
import ClientPeriodConsumptionDistributionChart from "../../components/ClientPeriodConsumptionDistributionChart.compound"
import {
  getClientPeriodConsumptionDistributionByArea,
  getClientPeriodConsumptionDistributionByProject,
} from "../../../../services/clientReport.service"
import { isPeriodInvalid } from "../../../../utils/clientReport.utils"
import { isObjectEmpty } from "../../../../utils/object.utils"
import { getTeamColor } from "../../../../utils/teamAreas.utils"
import useReportFiltersContext from "../../../../hooks/contextConsumers/useReportFiltersContext.hook"
import useClientColorsContext from "../../../../hooks/contextConsumers/useClientColorsContext.hook"
import { getPieChartColorSubtone } from "../../../../utils/component.utils"
import ClientProjectChip from "../../../../components/molecules/ClientProjectChip.molecule"
import { CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES } from "../../../../consts/modules/clientReport.consts"

const ClientPeriodConsumptionDistribution = ({ selectedPeriod, refresh }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [selectedMode, setSelectedMode] = useState(
    CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_AREA
  )
  const { clientReportSelectedClient } = useReportFiltersContext()
  const { colors } = useClientColorsContext()
  const hasMultipleProjects =
    (
      selectedPeriod?.hasMultipleProjects !== null &&
      selectedPeriod?.hasMultipleProjects !== undefined
    ) ?
      selectedPeriod?.hasMultipleProjects
    : colors.find((c) => c.id === clientReportSelectedClient)?.projects.length >
      1
  useEffect(() => {
    fetchPeriodConsumptionDistributionByArea()
  }, [selectedPeriod, refresh, selectedMode])
  useEffect(() => {
    setSelectedMode(CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_AREA)
  }, [selectedPeriod?.clientId])
  const fetchPeriodConsumptionDistributionByArea = async () => {
    setLoading(true)
    try {
      if (isPeriodInvalid(selectedPeriod)) {
        setData({})
        return
      }
      const serviceMethod =
        (
          selectedMode ===
          CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_AREA
        ) ?
          getClientPeriodConsumptionDistributionByArea
        : getClientPeriodConsumptionDistributionByProject
      const response = await serviceMethod(
        selectedPeriod.id,
        selectedPeriod.clientConsumptionPeriodType
      )
      if (!response.success) {
        throw new Error(response.message)
      }
      const result = response.result || []
      if (isObjectEmpty(result)) {
        setData([])
        return
      }
      setData([
        {
          data: Object.keys(result).map((area, index) => {
            let color = "var(--blue-600)"
            let label = result[area].name
            if (
              selectedMode ===
              CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_AREA
            ) {
              color = getTeamColor(area)
            } else if (
              selectedMode ===
              CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_PROJECT
            ) {
              const client = colors.find(
                (c) => c.id === clientReportSelectedClient
              )
              color = getPieChartColorSubtone(client?.color, index)
              label = (
                <ClientProjectChip
                  clientCode={client?.code}
                  projectCode={area}
                  color={client?.color}
                  showTooltip={false}
                />
              )
            }
            return {
              name: area,
              value: result[area].value,
              color,
              extraInfo: {
                name: name,
                label,
                teamMembers: result[area].teamMembers || [],
              },
            }
          }),
        },
      ])
    } catch (error) {
      console.error("Error fetching period consumption distribution:", error)
    } finally {
      setLoading(false)
    }
  }

  const getDistributionCardOptions = () => {
    return [
      {
        label: "Por equipos",
        value: CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_AREA,
      },
      ...(hasMultipleProjects ?
        [
          {
            label: "Por proyectos",
            value: CLIENT_REPORT_CONSUMPTION_DISTRIBUTION_CARD_MODES.BY_PROJECT,
          },
        ]
      : []),
    ]
  }
  return (
    <ClientReportCard
      title={"Distribución de consumo"}
      iconClassName={"pi pi-briefcase text-3xl"}
      className="flex-1 font-cairo flex-shrink-0"
      headerButton={
        hasMultipleProjects ?
          <DistributionCardModeDropdown
            key={hasMultipleProjects}
            selectedMode={selectedMode}
            setSelectedMode={setSelectedMode}
            options={getDistributionCardOptions()}
            disabled={loading || isObjectEmpty(data)}
          />
        : null
      }
    >
      <ClientPeriodConsumptionDistributionChart
        key={selectedMode}
        data={data}
        loading={loading}
        selectedMode={selectedMode}
      />
    </ClientReportCard>
  )
}

const DistributionCardModeDropdown = ({
  selectedMode,
  setSelectedMode,
  options = [],
  disabled = false,
}) => {
  return (
    <Dropdown
      value={selectedMode}
      options={options}
      onChange={(e) => setSelectedMode(e.value)}
      optionLabel="label"
      optionValue="value"
      disabled={disabled}
    />
  )
}

export default ClientPeriodConsumptionDistribution
